import { useState, useTransition } from 'react';

export const getFilterKey = (mainKey: string, subKey?: string, subKey2?: string, absoluteKey?: string) => {
  if (absoluteKey) {
    return absoluteKey;
  }
  if (subKey) {
    if (subKey2) {
      return `${mainKey}.${subKey}.${subKey2}`;
    }
    return `${mainKey}.${subKey}`;
  }
  return mainKey;
};

export const getFilterValue = (type: string, key: string, values: (string | number)[]) => {
  const filterValue = values.join(',');
  if (type === 'known' || type === 'unknown' || type === 'does_have' || type === 'doesnt_have') {
    return { filter: `${type}[${key}]`, filterValue: '' };
  }
  // else if (type === 'match') {
  //   return { filter: `match[${key}]=${type}`, filterValue: type };
  // }
  return { filter: `${type}[${key}]=${filterValue}`, filterValue: values.join('|||') };
};

export const isMultiValueFilter = (type: string | null) => {
  if (type === null) {
    return false;
  }
  return type.indexOf('between') > -1 || type.indexOf('range') > -1;
};

export const isInputValueRequired = (type: string | null) => {
  if (type === null) {
    return true;
  }
  return !(type === 'known' || type === 'unknown' || type === 'does_have' || type === 'doesnt_have');
};

export const useFiltersState = <T>(
  initValue: T,
  types: { name: string; value: string }[],
  selectedType: { name: string; value: string } | null
) => {
  let initValueFromToUse = initValue;
  let initValueToToUse = initValue;
  if (initValue !== null) {
    const values = initValue?.toString().split('|||') ?? [];
    initValueFromToUse = values[0] as T;
    if (values.length === 2) {
      initValueToToUse = values[1] as T;
    }
  }

  const fromState = useState<T>(initValueFromToUse);
  const toState = useState<T>(initValueToToUse);

  const typeState = useState<string | null>(selectedType?.value ?? null);
  const transition = useTransition();
  const showTwoValues = isMultiValueFilter(typeState[0]);

  const isTypeOnly = types.every(
    (t) => t.value === 'known' || t.value === 'unknown' || t.value === 'does_have' || t.value === 'doesnt_have'
  );

  const inputValueRequired = !isTypeOnly && isInputValueRequired(typeState[0]);

  return {
    showTwoValues,
    transition,
    typeState,
    fromState,
    toState,
    type: typeState[0],
    inputValueRequired,
    isTypeOnly,
  };
};
